import { IMaskInputProps, IMaskMixin } from 'react-imask';

import ControlledTextField, {
  ControlledTextFieldProps,
} from './ControlledTextField';

export type MaskedTextFieldProps = IMaskInputProps<HTMLInputElement> &
  ControlledTextFieldProps;

// There is a known bug with this library, IMaskMixin, Typescript, and custom input components.
// I was able to accurately type this here in the definition, but you'll notice when using it that
// TS will complain about the MUI TextField props. There was an issue on their github with movement
// as recent as November 2023, so I will fix this as soon as I get more time to either fix the library
// or the maintainers find a solution.
const MaskedTextField = IMaskMixin<HTMLInputElement, MaskedTextFieldProps>(
  ({ inputRef, defaultValue, ...otherProps }) => (
    <ControlledTextField {...otherProps} inputRef={inputRef} />
  )
);

export default MaskedTextField;
